<template>
  <div class="">
    <div style="display: flex; margin: 10px">
      <Y-button :button="addButton" :size="addSize" :style="{'fontSize': fonts}" @handleClickButton="handleClickButton"></Y-button>
    </div>
    <div class="content" style="display: flex; justify-content: space-around">
      <div class="left">
        <Y-form ref="forms" :form="columns" :formData="formData" @handleSelect="handleSelect" inline/>
      </div>
      <div class="right">
        <el-checkbox-group v-model="checkList" @change="handleChangeGroup">
          <el-checkbox v-for="(item, index) in checkListLabel" :label="item.label" :key="index" :style="{fontSize:fonts}"></el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
  </div>
</template>

<script>
import { insertOddNum, selectOddNum, upDataOddNum, deleteOddNum, } from "@/api/sysTem/codingSet";
import { checkFont } from "@/utils/methods";
import clone from "clone"
export default {
  name: "codingSet",
  props: {
    codingSetData: {
      type: Object,
      default: {}
    }
  },
  components: {},
  data() {
    return {
      addButton: [
        {
          key: "save",
          label: this.$t('listOfSet.save'),
          type: "success",
          icon: "el-icon-success",
        },
      ],
      addSize: "mini",
      checkList: [],
      checkListLabel: [
        { label: this.$t('listOfSet.year') },
        { label:  this.$t('listOfSet.years') },
        { label:  this.$t('listOfSet.month') },
        { label: this.$t('listOfSet.date')},
        { label:  this.$t('listOfSet.fixedContent1') },
        { label:  this.$t('listOfSet.fixedContent2') },
        { label:  this.$t('listOfSet.serialNumber') },
        { label:  this.$t('listOfSet.loginId') },
        { label:  this.$t('listOfSet.formField1') },
        { label:  this.$t('listOfSet.formField2') },
        { label:  this.$t('listOfSet.formField3') },
        { label:  this.$t('listOfSet.formField4') },
        { label:  this.$t('listOfSet.formField5') },
      ],
      columns: [
        { prop: "serialNoDigit", label:  this.$t('listOfSet.serialNoDigit'), },
        { prop: "bigSerial", label:  this.$t('listOfSet.bigSerial'), type: "select",
          list: [
            { label:this.$t('configMoudle.selectNo'), value: "false" },
            { label: this.$t('configMoudle.selectYes'), value: "true" },
          ],
        },
        { prop: "serialNoKey", label: this.$t('configMoudle.waterKey'), type: "multipleSelect",
          list: [
            { label: this.$t('formSet.year'), value: "年" },
            { label:  this.$t('formSet.month'), value: "月" },
            { label: this.$t('formSet.day'), value: "日" },
            { label:  this.$t('listOfSet.loginId'), value: "登录人ID" },
            { label: this.$t('listOfSet.formField1'), value: "表单字段1" },
            { label:this.$t('listOfSet.formField2'), value: "表单字段2" },
            { label: this.$t('listOfSet.formField3'), value: "表单字段3" },
            { label: this.$t('listOfSet.formField4'), value: "表单字段4" },
            { label:this.$t('listOfSet.formField5'), value: "表单字段5" },
          ],
        },
        { prop: "fixedContent1", label:  this.$t('listOfSet.fixedContent1'), },
        { prop: "fixedContent2", label:  this.$t('listOfSet.fixedContent2'), },
        { prop: "formField1", label:  this.$t('listOfSet.formField1'), },
        { prop: "formField2", label:  this.$t('listOfSet.formField2'), },
        { prop: "formField3", label:  this.$t('listOfSet.formField3'), },
        { prop: "formField4", label:  this.$t('listOfSet.formField4'), },
        { prop: "formField5", label:  this.$t('listOfSet.formField5'), },
        { prop: "smallSerialStart", label:  this.$t('listOfSet.smallSerialStart'), },
        { prop: "pattern", type:'textarea', label:  this.$t('listOfSet.pattern'), disabled: true, },
      ],
      formData: {},
      isSave: true,
      dataId: "",
      fonts: null,
      portData: {},
      ObjCodingSet: {}
    };
  },
  computed: {
    fieldId() {
      return this.$route.query.fieldId || this.ObjCodingSet.id;
    },
    formId() {
      return this.$route.query.formId || this.ObjCodingSet.formConfigId;
    },
    fieldName() {
      return this.$route.query.fieldName || this.ObjCodingSet.fieldName;
    },
    rowId() {
      return this.$route.query.rowId || this.ObjCodingSet.id;
    },
  },
  watch: {
    codingSetData: {
      handler(newVal, oldVal) {
        this.ObjCodingSet = newVal
      }, deep: true, immediate: true
    }
  },
  created() {
    this.init();
  },
  activated() {
    this.formData = {}
    this.checkList = []
    this.init();
  },
  mounted() {
    let font = checkFont();
    this.fonts = font
  },
  methods: {
    init() {
      selectOddNum({ itemConfigId: this.fieldId || this.ObjCodingSet.id }).then((res) => {
        if (res) {
          res.bigSerial = res.bigSerial ? (res.bigSerial = "true") : (res.bigSerial = "false")
          if (res.serialNoKey && res.serialNoKey !== null && res.serialNoKey !== undefined) {
            res.serialNoKey = res.serialNoKey.split("+")
          }
          this.portData = res
          let newObjOne = clone(res)
          this.$refs.forms.curData = newObjOne;
          this.dataId = res.id;
          if (res.pattern && res.pattern !== null && res.pattern !== undefined) {
            this.checkList = res.pattern.split("+");
          } else this.checkList = []
          this.isSave = false;
          let index = 0;
          this.addButton.forEach((item, i) => {
            if (item.key == "delete") index = i;
          });
          if (!index) {
            this.addButton.push({
              key: "delete",
              label:  this.$t('listOfSet.delete'),
              type: "warning",
              icon: "el-icon-delete",
            });
          }
        } else {
          for (let i in this.$refs.forms.curData) {
            this.$refs.forms.curData[i] = "";
            this.checkList = [];
            this.addButton.forEach((item, index) => {
              if (item.key == "delete") {
                this.addButton.splice(index, 1);
              }
            });
          }
          this.isSave = true;
        }
      });
    },
    handleClickButton(val) {
      switch (val) {
        case "save":
          console.error('this.ObjCodingSet', this.ObjCodingSet)
          const obj = {
            fieldId: this.fieldId || this.ObjCodingSet.id,
            fieldName: this.fieldName || this.ObjCodingSet.fieldName,
            formId: this.formId || this.ObjCodingSet.formConfigId
          };
          if (!obj.fieldName && this.ObjCodingSet.itemName) {
            obj.fieldName = this.ObjCodingSet.itemName
          }
          const newobj = { ...this.$refs.forms.curData, ...obj };
          if (newobj.serialNoKey?.length) {
            newobj.serialNoKey = newobj.serialNoKey.join("+")
          } else newobj.serialNoKey = ""
          newobj.bigSerial = newobj.bigSerial === "true";

          if (this.isSave) {
            insertOddNum(newobj).then((res) => {
              this.$message({ message:this.$t('editUserAdmin.saveSuccess'), type: 'success' })
              this.init();
            });
          } else {
            // let newObjOne = clone(newobj)
            // this.portData.serialNoKey = this.portData.serialNoKey.join("+")
            // if (this.portData.bigSerial == "true" || this.portData.bigSerial == true) {
            //   this.portData.bigSerial = true
            // } else this.portData.bigSerial = false
            // let arrys = []
            // this.columns.forEach(item => {
            //   if (newObjOne[item.prop] !== this.portData[item.prop]) {
            //     if (item.prop !== "smallSerialStart") {
            //       arrys.push(item.prop)
            //     }
            //   }
            // })
            // if (arrys.length > 0) {
            //   upDataOddNum(newobj).then((res) => {
            //     this.$message({ message: this.$t('editUserAdmin.saveSuccess'), type: 'success' })
            //     this.init();
            //   });
            // } else this.$message.error("请修改相关数据")


            let newObjOne = clone(newobj);
            this.portData.serialNoKey = typeof this.portData.serialNoKey === 'array' ? this.portData.serialNoKey.join("+") : this.portData.serialNoKey;
            this.portData.bigSerial = this.portData.bigSerial === "true" || this.portData.bigSerial === true;
            let arrys = [];
            this.columns.forEach(item => {
              if (newObjOne[item.prop] !== this.portData[item.prop] && item.prop !== "smallSerialStart") {
                arrys.push(item.prop);
              }
            });
            if (arrys.length > 0) {
              upDataOddNum(newobj).then((res) => {
                this.$message({ message: this.$t('editUserAdmin.saveSuccess'), type: 'success' });
                this.init();
              });
            } else this.$message.error("请修改相关数据");
          }
          break;
        case "delete":
          deleteOddNum(this.dataId).then((res) => {
            this.init();
          });
          break;
        default:
          break;
      }
    },
    handleSelect() {},
    handleChangeGroup(val) {
      val = val.join("+");
      this.$refs.forms.curData.pattern = val;
    },
  },
  updated() {},
};
</script>

<style scoped lang='less'>
</style>
